export class ModelError {
  constructor(key: string, errors?: string[] | string, isPersistent?: boolean) {
    this.Key = key;
    if (!isPersistent)
        this.IsPersistent = false;
    else
        this.IsPersistent = isPersistent;

    if (!errors) {
      return;
    }

    if (Array.isArray(errors)) {
      this.Messages = <Array<string>>errors;
    } else {
      this.Messages.push(<string>errors);
    }
  }

  public Key: string;
  public Messages: Array<string> = [];
  public IsShown: boolean = false;
  public IsPersistent?: boolean = false;

  public static parseFromModelState(
    errors: { [key: string]: string[] },
    prefix: string = '',
    isPersistent?: boolean
  ): ModelError[] {

    var keys = Object.keys(errors || []);
    var countOfKeys = keys.length;
    var errorModels: ModelError[] = [];
    if (prefix) {
      prefix = prefix + '.';
    }

    for (var i = 0; i < countOfKeys; i++) {
      var newKey = keys[i];
      if (newKey.indexOf('model.') == 0) {
        newKey = newKey.replace('model.', '');
      }
      errorModels.push(new ModelError(prefix + newKey, errors[keys[i]], isPersistent));
    }

    return errorModels;
  }

  public get keyMessages(): string {
    return `${this.Key} : [${this.Messages.join(', ')}]`;
  }

  public get text(): string {
    return `${this.Messages.join(', ')}`;
  }
}
